import React from 'react';
import ArticleItem from 'app/components/blog/ArticleItem';
import ArticleLoader from 'app/components/blog/ArticleLoader';
import { Paginate } from 'app/seedly-component-library';

const ArticleList = props => {
  const {
    articles = [],
    currentPage = 1,
    totalPage = 1,
    onPageChange,
    loading,
    renderEmptyList = () => null,
  } = props;

  if (loading) return <ArticleLoader />;

  if (!articles.length) return renderEmptyList();

  const havePaginate = Boolean(totalPage) && totalPage > 1 && onPageChange;

  return (
    <div>
      <ul>
        {articles.map((article, index) => {
          return (
            <li className="mb-1" key={index}>
              <ArticleItem article={article} />
            </li>
          );
        })}
      </ul>
      {havePaginate && (
        <div className="my-6 flex items-center justify-center">
          <Paginate
            pageCount={totalPage}
            forcePage={currentPage - 1}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default ArticleList;
